import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Table } from '../../components/ui/Table.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { financeApi } from '../../services/financeApi.js';

import { PaymentTermModal } from './PaymentTermModal.jsx';
import { SkontoCalculatorModal } from './SkontoCalculatorModal.jsx';

export function PaymentTermsPage() {
  const { t } = useTranslation();
  const [createOpen, setCreateOpen] = useState(false);
  const [calcOpen, setCalcOpen] = useState(false);

  const list = useQuery({ queryKey: ['finance', 'payment-terms'], queryFn: () => financeApi.listPaymentTerms().then((r) => r.items) });
  const rows = list.data || [];

  const columns = [
    { key: 'code', label: t('pt.col.code'), render: (r) => <span className="mono"><strong>{r.code}</strong></span> },
    { key: 'name', label: t('pt.col.name') },
    { key: 'net', label: t('pt.col.net'), align: 'right', render: (r) => `${r.netDays} ${t('pt.days')}` },
    { key: 'discount', label: t('pt.col.discount'), align: 'right', render: (r) => (Number(r.discountPercent) > 0 ? `${Number(r.discountPercent).toFixed(2)} % / ${r.discountDays} ${t('pt.days')}` : '-') },
  ];

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1>{t('pt.title')}</h1>
          <p className="muted">{t('pt.subtitle')}</p>
        </div>
        <div className="page-actions">
          <Button variant="ghost" onClick={() => setCalcOpen(true)}>{t('pt.action.calc')}</Button>
          <Button variant="primary" onClick={() => setCreateOpen(true)}>{t('pt.action.new')}</Button>
        </div>
      </header>

      <Table columns={columns} rows={rows} isLoading={list.isLoading} emptyMessage={t('pt.empty')} />

      <PaymentTermModal open={createOpen} onClose={() => setCreateOpen(false)} />
      <SkontoCalculatorModal open={calcOpen} onClose={() => setCalcOpen(false)} terms={rows} />
    </section>
  );
}
